// services/locationApi.ts
import apiClient from "./apiClient";

export interface State {
  id: number;
  name: string;
  code: string;
}

export interface District {
  id: number;
  name: string;
  stateId: number;
}

export interface Area {
  id: number;
  name: string;
  organizationId: number;
}

export const locationApi = {
  getStates: async (): Promise<State[]> => {
    const response = await apiClient.get("/locations/states");
    return response.data;
  },
  getDistrictsByState: async (stateId: number): Promise<District[]> => {
    const response = await apiClient.get(`/locations/districts/${stateId}`);
    return response.data;
  },
  getAreas: async (): Promise<Area[]> => {
    const response = await apiClient.get("/customers/areas");
    return response.data?.areas || [];
  },
};
